import { render } from "./SectionsLanding.vue?vue&type=template&id=e10341ca&scoped=true"
import script from "./SectionsLanding.vue?vue&type=script&lang=js"
export * from "./SectionsLanding.vue?vue&type=script&lang=js"

import "./SectionsLanding.vue?vue&type=style&index=0&id=e10341ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e10341ca"]])

export default __exports__